import List from "components/list";
import { useParams } from "react-router-dom";
import { EmployeeCell } from "components/cell/employee/cell";
import { getUserFields } from "components/user/config";
import { DateCell } from "@/components/date/cell";
import { StatusCell } from "@/components/status/cell";
import ApplicantsInterviewsFilters from "./filters";

export default function ApplicantInterviews({ applicantId }) {

    const { openingId } = useParams();

    const fields = [
        "id",
        getUserFields("applicant.employee"),
        "title",
        "status",
        "date_scheduled",
        "is_cleared"
    ];

    const columns = [
        {
            id: "title",
            header: "Title",
            accessorKey: "title",
        },
        {
            id: "status",
            header: "Status",
            accessorKey: "status",
            cell: StatusCell,
        },
        {
            id: "date_scheduled",
            header: "Scheduled",
            accessorKey: "date_scheduled",
            cell: DateCell,
            sortable: true,
        },
        {
            id: "is_cleared",
            header: "Cleared",
            accessorKey: "is_cleared",
            cell: ({ row }) => {
                return row.original?.is_cleared ? "Yes" : "No";
            },
        }
    ];

    const defaultFilters = {
        applicant: {
            id: { _eq: applicantId }
        },
    };

    return (
        <div className="w-full">
            <div className="flex-1 h-full">
                <List
                    title="Interviews"
                    endPoint="opening_interviews"
                    storageKey={`interview-list-${applicantId}`}
                    showSearch={false}
                    perPage={10}
                    columns={columns}
                    filters={defaultFilters}
                    meta={{
                        fields,
                    }}
                    href={(item) => `/apps/openings/${openingId}/applicants/${applicantId}/${item.id}`}
                    renderFilters={ApplicantsInterviewsFilters}
                />
            </div>
        </div>
    );
}
